module.exports = __webpack_public_path__ + "img/index-bg-1.1f3006f5.svg";